import { newUpgrade } from '@ff-os/shared-utils/upgrades/newUpgrade';
import { Upgrade } from '@ff-os/shared-utils/upgrades/upgrades';
import { reduceProjectContent } from './2022-11-24-reduce-project-content/2022-11-24-reduce-project-content';

export const photoPrintsUpgrades: Upgrade[] = [
    newUpgrade('reduce-project-content', reduceProjectContent)
];